import { render } from "./2025Results.vue?vue&type=template&id=a97158e2&scoped=true"
import script from "./2025Results.vue?vue&type=script&lang=js"
export * from "./2025Results.vue?vue&type=script&lang=js"

import "./2025Results.vue?vue&type=style&index=0&id=a97158e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97158e2"]])

export default __exports__